import styled from 'styled-components';
import media from '../../styled/media';

export const Intro = styled.div`
  position: relative;
`;

export const IntroTextContainer = styled.div`
  padding: 32px 0;
  ${media.tablet`
    max-width: 50%;
    padding: 160px 40px 160px 0;
  `}
`;

export const IntroImageContainer = styled.div`
  ${media.tablet`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 50%;
  `}
`;

export const IntroHeading = styled.h1`
  font-weight: 400;
  font-size: 32px;
  line-height: 48px;
  ${media.tablet`
    font-size: 48px;
  `}
`;

export const IntroSubheading = styled.p`
  font-size: 20px;
  line-height: 28px;
  ${media.tablet`
    font-size: 26px;
    line-height: 34px;
  `}
`;

export const IntroDescription = styled.p``;

export const Integration = styled.div`
  background: #f5f5f5;
  padding: 40px 0;
  ${media.tablet`
    padding: 80px 0;
  `}
`;

export const IntegrationGrid = styled.div`
  ${media.tablet`
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  `}
`;

export const IntegrationGridItem = styled.div`
  ${media.tablet`
    width: 50%;
  `}
`;

export const IntegrationHeading = styled.p`
  font-size: 24px;
  text-align: center;
  ${media.tablet`
    font-size: 34px;
    line-height: 48px;
    text-align: inherit;
  `}
`;

export const IntegrationSubheading = styled.p`
  font-size: 18px;
  line-height: 28px;
  ${media.tablet`
    font-size: 24px;
    line-height: 32px;
  `}
`;

export const IntegrationDescription = styled.p`
  font-size: 14px;
  line-height: 24px;
  ${media.tablet`
    font-size: 16px;
  `}
`;

export const Clients = styled.div`
  padding: 40px 0;
  ${media.tablet`
    padding: 80px 0;
  `}
`;

export const ClientsContainer = styled.div`
  ${media.tablet`
    display: flex;
  `}
`;

export const ClientsCaption = styled.div`
  ${media.tablet`
    width: 50%;
    padding-right: 40px;
  `}
`;

export const ClientsHeading = styled.p`
  font-size: 24px;
  text-align: center;
  ${media.tablet`
    text-align: inherit;
    font-size: 34px;
    line-height: 48px;
  `}
`;

export const ClientsDescription = styled.p`
  font-size: 18px;
  line-height: 28px;
  ${media.tablet`
    font-size: 24px;
    line-height: 32px;
  `}
`;

export const ClientsBenefits = styled.div`
  text-align: center;
  ${media.tablet`
    width: 50%;
    text-align: inherit;
  `}
`;

export const ClientsBenefitsHeading = styled.p`
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  ${media.tablet`
    font-size: 16px;
  `}
`;

export const ClientsBenefitsItems = styled.div`
  ${media.tablet`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;
  `}
`;

export const ClientsBenefitsItem = styled.div`
  ${media.tablet`
    display: grid;
    grid-template-columns: max-content auto;
    grid-gap: 16px;
  `}
`;

export const ClientsBenefitsItemText = styled.p`
  font-size: 14px;
  line-height: 19px;
  margin: 0;
`;

export const Growing = styled.div`
  padding-top: 40px;
  background: #f5f5f5;
  ${media.tablet`
    padding: 80px 0;
  `}
`;

export const GrowingContainer = styled.div`
  ${media.tablet`
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  `}
`;

export const GrowingTextContainer = styled.div`
  ${media.tablet`
    width: 50%;
    padding-right: 20px;
  `}
`;

export const GrowingImageContainer = styled.div`
  margin: 0 -20px;
  ${media.tablet`
    margin: 0;
    width: 50%;
    padding-right: 40px;
  `}
`;

export const GrowingHeading = styled.p`
  font-size: 24px;
  text-align: center;
  ${media.tablet`
    text-align: initial;
    font-size: 34px;
    line-height: 48px;
  `}
`;

export const GrowingSubheading = styled.p`
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  ${media.tablet`
    font-size: 16px;
  `}
`;

export const GrowingList = styled.ul`
  font-size: 14px;
  line-height: 24px;
  list-style: initial;
  padding-left: 20px;
  margin-bottom: 40px;
  ${media.tablet`
    font-size: 16px;
  `}
`;

export const GrowingListItem = styled.li``;

export const Contact = styled.div`
  text-align: center;
  padding: 64px 0;
  background-color: #c6c6c6;
  ${media.tablet`
    padding: 80px 0;
    background-image: url('/images/partners/contact.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  `}
`;

export const ContactHeading = styled.p`
  font-size: 24px;
  ${media.tablet`
    font-size: 34px;
    line-height: 48px;
  `}
`;

export const ContactDescription = styled.p`
  font-size: 18px;
  line-height: 28px;
  ${media.tablet`
    font-size: 24px;
    line-height: 32px;
  `}
`;
